import { BlogTemplate } from './blog';

export default BlogTemplate;
